export const experiences = {
    employment: [
        {
            company: "Meta",
            role: "Software Engineer Intern - ENT framework, Menlo Park, CA",
            date: "May 2024 - Aug 2024",
            details: [
                "Built and optimized a code generation API in PHP/Hack within Meta's EntFramework to streamline test case creation and validation for backend systems like TAO and ZippyDB, enabling efficient testing of social graph data used by internal platforms.",
                "Boosted API adoption by over 40% among Meta engineers, streamlining data testing workflows across key platforms and improving engineering productivity.",
                "Partnered with senior engineers to architect and deploy a scalable API solution, meeting complex system requirements and ensuring seamless integration with existing Meta infrastructure."
            ]
        },
        {
            company: "Amazon",
            role: "Software Development Engineer Intern - AWS Lake Formation, East Palo Alto, CA",
            date: "May 2023 - Aug 2023",
            details: [
                "Utilized Python and Ruby to build an automated deployment pipeline for Model Change Management (MCM), cutting execution time by 95% and making infrastructure workflows more efficient.",
                "Added timestamp support to data cell filters with Java, which improved data traceability and fine grained access control in AWS Lake Formation.",
                "Developed and supported backend features using Java, Python, and Ruby in AWS, working directly with services like IAM, CloudFormation, and Lake Formation."
            ]
        },
        {
            company: "Howard University",
            role: "Teaching Assistant, Washington, DC",
            date: "Oct 2024 - Dec 2024",
            details: [
                "Assisted with grading assignments and providing feedback to students in the Explore to Computer Science (CSCI 120) course.",
                "Collaborated with faculty to  develop course materials to enhance the student learning experience.",
                "Assisted students in exploring the field of computer science and identifying potential career opportunities."
            ]
        }
    ],
    research: [
        {
            company: "Texas A&M University",
            role: "Graduate Research Assistant - Graph RAG, College Station, TX",
            date: "Jan 2026 - Present",
            details: [
                "Developing a Graph RAG pipeline to improve answer quality and reduce query latency for long-context Q&A by leveraging Qwen LLM for semantic chunking and the NV-Embed-v2 embedding model for optimized node retrieval.",
                "Built a lightweight graph-memory layout that minimizes memory footprint relative to HippoRAG while maintaining high accuracy for multi-hop reasoning across extensive multi-document corpora."
            ]
        },
        {
            company: "Howard University",
            role: "Research Assistant - Phase Based Motion Processing, Washington, DC",
            date: "Oct 2023 - April 2024",
            details: [
                "Developed and implemented video motion algorithms in C++ and MATLAB for processing large scale video datasets, facilitating the detection of subtle infrastructural changes.",
                "Enhanced video processing pipeline efficiency, achieving a 20% reduction in computation time and enabling near real-time monitoring for structural integrity.",
                "Co-authored a published paper in the ASCE Library on video and signal processing for infrastructure monitoring."
            ]
        },
        {
            company: "Howard University",
            role: "Research Assistant, Washington, DC",
            date: "May 2022 - Dec 2022",
            details: [
                "Tested the YALE datasets of around 100k images and used it for facial and ear recognition using Python.",
                "Achieved a 90% accuracy rate for facial recognition algorithms and 75% for ear recognition algorithms by testing and refining them with editing software like Adobe Photoshop to add occlusions, adjust lighting, and enhance image quality."
            ]
        }
    ]
};
